module.exports = __webpack_public_path__ + "6c9425f6e58dc7993ddf5ba28022b405.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/heros/api-signup.png
// module id = 631
// module chunks = 0